var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37256 18.6274 0 12 0C5.37258 0 0 5.37256 0 12C0.007164 18.6245 5.37555 23.9927 12 24ZM7.264 16.541V8.54102C7.264 7.7124 7.93557 7.04102 8.764 7.04102H9.236C10.0644 7.04102 10.736 7.7124 10.736 8.54102V16.541C10.736 17.3696 10.0644 18.041 9.236 18.041H8.764C7.93557 18.041 7.264 17.3696 7.264 16.541ZM14.708 7.04102C13.8796 7.04102 13.208 7.7124 13.208 8.54102V16.541C13.208 17.3696 13.8796 18.041 14.708 18.041H15.236C16.0644 18.041 16.736 17.3696 16.736 16.541V8.54102C16.736 7.7124 16.0644 7.04102 15.236 7.04102H14.708Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.1822d395.svg";
export { ForwardRef as ReactComponent };